import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ChartLineSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ChartLineSVG;
